// 菜单 侧边栏
export default [
  /**{
    title: '数据中心',
    icon: 'bar-chart',
    children: [{
      title: '流水概览',
      path: '/preview',
      icon: 'globe',
    }]
  }**/
]